module.exports = __webpack_public_path__ + "img/bold-icon Call line.5699f55c.svg";